import React, {FC, memo, useCallback, useState} from 'react'
import classnames from 'classnames'
import isEmpty from 'lodash/isEmpty'
import './PinnedMessages.css';
import { FiChevronDown } from "react-icons/fi";
import {setGridAreaContent} from "../app/App.action";
import {useStateValue} from "../state-provider/StateProvider";
import {LiveChatHistoryItem} from "../../api/types";
import useIsMobile from "../../hooks/useIsMobile";

const PinnedMessagesComponent: FC<{
  liveChatLatestMessages: LiveChatHistoryItem[] | undefined,
  isLiveChatVisible: boolean,
  pinned: LiveChatHistoryItem[] | undefined,
  isControlBarHidden: boolean,
  currentLiveStreamUrl: string | undefined,
}> = ({
  liveChatLatestMessages,
  isLiveChatVisible,
  pinned,
  isControlBarHidden,
  currentLiveStreamUrl
}) => {
  const isMobile = useIsMobile()
  const [isPreviewSectionVisible, showPreview] = useState(!isMobile)
  const onPreviewIconClick = () => {
    showPreview(!isPreviewSectionVisible)
  }

  const [{
    brand,
  }, dispatch] = useStateValue()

  const showChat = useCallback(() => {
    dispatch(setGridAreaContent('LiveChat'));
  }, [dispatch])


  return (
    <div className={classnames("live-chat-preview", { expanded: !isControlBarHidden, 'is-width-reduced': !!currentLiveStreamUrl})}>
      {!isLiveChatVisible &&
        <>
          {
            <FiChevronDown
              className={classnames("show-chat-preview", { "is-opened": isPreviewSectionVisible })}
              onClick={() => onPreviewIconClick()}
            />
          }
          <div
            className={classnames("live-chat-container", { 'show': isPreviewSectionVisible })}
            onClick={() => {
              showChat()
            }}
          >
            {!isEmpty(liveChatLatestMessages) &&
              liveChatLatestMessages?.map((message) => (
                <div key={`message-${message.id}`} className="preview-history-item">

                  <span className="preview-message"><span className="preview-username">{message.user.name}</span>{message.message}</span>
                </div>
              ))}
          </div>
        </>}
      { brand && pinned && pinned.length > 0 && (
        <div className="pinned-messages-wrapper" onClick={() => {
          showChat()
        }}>
          {pinned.map(p => {
            return <div key={`pinned-${p.id}`} className={classnames("pinned-message", { 'is-message-cropped': !currentLiveStreamUrl })}>

                <span className="preview-content">
                  <span className="preview-brandname">{p.user.name} &#11089;</span>{p.message}</span>
              </div>

          }
          )}</div>
      )}
    </div>
  )
}
export const PinnedMessages = memo(PinnedMessagesComponent)